import useGlobalState from 'components/App/globalstate/useGlobalState';

const usePasswordEvent = () => useGlobalState().passwordEvent;

export default usePasswordEvent;
